import React from "react";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import GenericNotFoundPage from "~/components/element/NotFoundPage";

const NotFoundPage = observer(props => (
  <GenericNotFoundPage helpText={props.t("sorryPageNotFound")} continueUrl="/tours" continueText={props.t("myTours")} />
));

export default withTranslation()(NotFoundPage);
